module.exports = __webpack_public_path__ + "static/media/Leads_logo.1380f99f.png";